import _typeof from "@babel/runtime/helpers/esm/typeof";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
import { c as _c } from "react-compiler-runtime";
import React, { Suspense, useRef, useEffect } from 'react';
import useFetchCart from '@nike/shop-apis/buy/carts/v2/fetch/use-query';
import useAdobeTarget from '@nike/shop-apis/adobe-target/use-query';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import { ButtonStyled } from '@nike/nike-design-system-components';
import trackMiniBagAction, { MINI_BAG_AT_ACTIVITY_NAME, MINI_BAG_AT_EXPERIENCES, MINI_BAG_AT_LOCATION_NAME } from './mini-bag-analytics';
import { Actions } from "../base/styles";
import CheckoutButton from "../../checkout-button/CheckoutButton";
import trackEvent from "../../../analytics/track-event";
import getViewAppData from "../../../analytics/get-view-app-data";
var MINI_BAG_CONTROL_COHORT = 'control';
var LazyEnhancedActions = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./EnhancedCartItemAddedModalActions'));
  });
});
var OriginalCartItemAddedModalActions = function OriginalCartItemAddedModalActions() {
  var $ = _c(17);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      select: _temp,
      placeholderData: {
        totals: {
          quantity: 0
        }
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var _useFetchCart = useFetchCart(t0),
    totalCartQuantity = _useFetchCart.data;
  var ctaClickedRef = useRef(false);
  var t1;
  var t2;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = function t1() {
      return function () {
        if (!ctaClickedRef.current) {
          trackMiniBagAction({
            actionName: "mini-bag:dismiss",
            cohort: MINI_BAG_CONTROL_COHORT
          });
        }
      };
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  var t3;
  if ($[3] === Symbol["for"]("react.memo_cache_sentinel")) {
    t3 = function t3(actionName) {
      ctaClickedRef.current = true;
      trackMiniBagAction({
        actionName: actionName,
        cohort: MINI_BAG_CONTROL_COHORT
      });
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  var handleCtaClick = t3;
  var t4;
  if ($[4] === Symbol["for"]("react.memo_cache_sentinel")) {
    t4 = {
      stringKey: "wishlist.cartButton",
      primaryValue: "View Cart",
      description: "view cart"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  var viewCartString = useI18nString(t4);
  var t5;
  if ($[5] === Symbol["for"]("react.memo_cache_sentinel")) {
    t5 = {
      stringKey: "cta.checkoutBtn",
      primaryValue: "Checkout",
      description: "default checkout link on desktop."
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  var checkoutString = useI18nString(t5);
  var t6;
  var t7;
  if ($[6] === Symbol["for"]("react.memo_cache_sentinel")) {
    var _window$NikeShop;
    t6 = (_window$NikeShop = window.NikeShop) === null || _window$NikeShop === void 0 || (_window$NikeShop = _window$NikeShop.get()) === null || _window$NikeShop === void 0 ? void 0 : _window$NikeShop.cartHref;
    t7 = function t7() {
      handleCtaClick("mini-bag:view-bag");
      trackEvent("View Cart Clicked", getViewAppData());
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  var t8 = " (".concat(totalCartQuantity, ")");
  var t9;
  if ($[8] !== t8 || $[9] !== viewCartString) {
    t9 = /*#__PURE__*/React.createElement(ButtonStyled, {
      appearance: "secondary",
      size: "large",
      type: "button",
      Component: "a",
      href: t6,
      onClick: t7,
      "data-automation": "cart-item-added-modal-view-cart-button"
    }, viewCartString, t8);
    $[8] = t8;
    $[9] = viewCartString;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  var t10;
  if ($[11] === Symbol["for"]("react.memo_cache_sentinel")) {
    t10 = function t10() {
      return handleCtaClick("mini-bag:checkout");
    };
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  var t11;
  if ($[12] !== checkoutString) {
    t11 = /*#__PURE__*/React.createElement(CheckoutButton, {
      onClick: t10
    }, checkoutString);
    $[12] = checkoutString;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  var t12;
  if ($[14] !== t11 || $[15] !== t9) {
    t12 = /*#__PURE__*/React.createElement(Actions, null, t9, t11);
    $[14] = t11;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
};
var CartItemAddedModalActions = function CartItemAddedModalActions() {
  var $ = _c(4);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      activityName: MINI_BAG_AT_ACTIVITY_NAME,
      experiences: MINI_BAG_AT_EXPERIENCES,
      locationName: MINI_BAG_AT_LOCATION_NAME
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var _useAdobeTarget = useAdobeTarget(t0),
    experience = _useAdobeTarget.experience;
  var isEnhanced = experience === "B" || experience === "C";
  if (isEnhanced) {
    var _t;
    if ($[1] !== experience) {
      _t = /*#__PURE__*/React.createElement(Suspense, {
        fallback: null
      }, /*#__PURE__*/React.createElement(LazyEnhancedActions, {
        experience: experience
      }));
      $[1] = experience;
      $[2] = _t;
    } else {
      _t = $[2];
    }
    return _t;
  }
  var t1;
  if ($[3] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/React.createElement(OriginalCartItemAddedModalActions, null);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default CartItemAddedModalActions;
function _temp(cart) {
  var _cart$totals$quantity, _cart$totals;
  return (_cart$totals$quantity = cart === null || cart === void 0 || (_cart$totals = cart.totals) === null || _cart$totals === void 0 ? void 0 : _cart$totals.quantity) !== null && _cart$totals$quantity !== void 0 ? _cart$totals$quantity : 0;
}